// extracted by mini-css-extract-plugin
module.exports = {"type":"PhoneNumber_type__2fHlu","number":"PhoneNumber_number__3QMUx"};